module.exports = __webpack_public_path__ + "img/bottom.9bcd0bec.png";